export enum TagsServiceTypeEnum {
  OFFERS = 'offers',
  EVENTS = 'EVENTS'
}



// WEBPACK FOOTER //
// ./src/app/enums/tags-service-type.enum.ts